import type { CampaignAttribution } from "./campaign-attribution";

const EMPLOYER_DRAFT_KEY = "peakwave_employer_signup_draft";
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export interface EmployerSignupDraft {
  version: 1;
  createdAt: string;
  companyName: string;
  contactName?: string;
  email: string;
  location: string;
  industry: string;
  companySize: string;
  campaignAttribution?: CampaignAttribution | null;
  seasonTypes?: string[];
  hiringRoleCategories?: string[];
  /** "How did you hear about PeakWave?" option id (optional). */
  heardAbout?: string;
  /** Free text, only with heardAbout = "other". */
  heardAboutOther?: string;
  /** First-party page or CTA that sent the visitor. */
  entrySource?: string;
  inviteId?: string;
  companyId?: string;
  firstListing?: {
    roleCategory: string;
    seasonTypes: string[];
    region: string | null;
    titleOverride?: string;
  };
}

export function saveEmployerSignupDraft(draft: EmployerSignupDraft): void {
  try {
    localStorage.setItem(EMPLOYER_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // localStorage may be unavailable
  }
}

export function loadEmployerSignupDraft(): EmployerSignupDraft | null {
  try {
    const raw = localStorage.getItem(EMPLOYER_DRAFT_KEY);
    if (!raw) return null;
    const draft = JSON.parse(raw) as EmployerSignupDraft;
    if (draft.version !== 1) return null;
    // Discard if older than 7 days
    if (Date.now() - new Date(draft.createdAt).getTime() > MAX_AGE_MS) {
      localStorage.removeItem(EMPLOYER_DRAFT_KEY);
      return null;
    }
    return draft;
  } catch {
    return null;
  }
}

export function clearEmployerSignupDraft(): void {
  try {
    localStorage.removeItem(EMPLOYER_DRAFT_KEY);
  } catch {
    // localStorage may be unavailable
  }
}
